import {createSelector} from 'reselect';
import { ModelName } from '../../../models';
import { selectRootState } from '../../../store/selectors';

export const selectDashboardState = createSelector(
    [selectRootState],
    state => state.dashboard,
  );


export const selectDashnoardData= createSelector(
    [selectDashboardState],
    state => ({
        totalMeetingsScheduled: state.totalMeetingsScheduled,
        totalMeetingsCancelled:  state.totalMeetingsCancelled,
        totalMeetingsCompleted: state.totalMeetingsCompleted,
        totalMeetingsPending:  state.totalMeetingsCompleted
    })
)

export const selectDashboardLoading= createSelector(
    [selectDashboardState],
    state => state.loading
)

export const selectUnverified= function<T> (type: string) {
    return createSelector(
        [selectDashboardState],
        state => state[type] as T
    )
}
export const selectFormState = createSelector(
    [selectRootState],
    state => state.form,
  );

  export const selectFormValues = (name: string) => createSelector(
    [selectFormState],
    state => {
        if(!state) {
            return null;
        }
        if(!state[name]) {
            return null
        }
        return state[name].values;
    },
  );


export const selectCreatingModel = (modelName: ModelName) => createSelector(
    [selectDashboardState],
    state => {
      const modelState =  state.createdModels[modelName]
      if(!modelState) 
            return false;
      return modelState.loading
    }
)

